import { createSelector } from 'reselect';
import { getAllTimeBounds } from '../reducers/timeBounds';
import { getCrimeType } from './options';

export const getSafeTimeBounds = createSelector(
  getAllTimeBounds,
  getCrimeType,
  (timeBounds, crimeType) => {
    switch (crimeType) {
      case 1:
      case '1':
        return timeBounds.murders;
      case null:
        return null;
      default:
        return timeBounds.shootings;
    }
  },
);



// WEBPACK FOOTER //
// ./src/selectors/timeBounds.js